module.exports = (clickedItem, listTarget) => clickedItem.getAttribute("id") === listTarget.getAttribute("id");
